import React, { useEffect, useMemo, useState } from 'react';

interface ConfettiBurstProps {
  show: boolean;
  colors: string[];
}

type ConfettiStyle = React.CSSProperties & {
  '--confetti-x'?: string;
};

const PIECE_COUNT = 48;

const ConfettiBurst: React.FC<ConfettiBurstProps> = ({ show, colors }) => {
  const [burstId, setBurstId] = useState(0);

  useEffect(() => {
    if (show) {
      setBurstId(prev => prev + 1);
    }
  }, [show]);

  const pieces = useMemo(() => {
    const seed = Math.max(burstId, 1);
    return Array.from({ length: PIECE_COUNT }, (_, idx) => {
      const paletteColor = colors[idx % colors.length] || '#ffffff';
      const offset = ((idx + 1) * seed * 13) % 100;
      return {
        id: idx,
        left: (Math.random() * 60 + offset) % 100,
        size: 6 + Math.random() * 8,
        delay: Math.random() * 0.2,
        duration: 1.1 + Math.random() * 0.6,
        color: paletteColor,
        xMove: -80 + ((idx + seed) % 12) * 12,
      };
    });
  }, [burstId, colors]);

  if (!show) return null;

  return (
    <div className="confetti-wrapper">
      {pieces.map(piece => {
        const style: ConfettiStyle = {
          left: `${piece.left}%`,
          width: `${piece.size}px`,
          height: `${piece.size * 0.45}px`,
          animationDelay: `${piece.delay}s`,
          animationDuration: `${piece.duration}s`,
          backgroundColor: piece.color,
          boxShadow: `0 0 12px ${piece.color}55`,
          '--confetti-x': `${piece.xMove}px`,
        };

        return <span key={`${burstId}-${piece.id}`} className="confetti-piece" style={style} />;
      })}
    </div>
  );
};

export default ConfettiBurst;
